import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ApiClient } from '../utils/api/client';
import { useApiEngine } from '../utils/api/engine';
import { createContext, useContext } from 'react';

const queryClient = new QueryClient();

const ApiContext = createContext<any>(null);

export function ApiProvider({ children }: { children: React.ReactNode }) {
  const api = useApiEngine({
    client: ApiClient,
    queryClient,
  });

  return (
    <ApiContext.Provider value={api}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </ApiContext.Provider>
  );
}

export const useApi = () => useContext(ApiContext);
